import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UnsubscribeComponent } from "../../../../generals/Components";
import { AdminModuleDetail, Category, LabelValueNumber, ModuleGlobizFeedImportCategory, ModuleGlobizFeedImportCategoryMatcher, ModuleGlobizFeedImportConfig, ModuleGlobizFeedImportConfigCategories, ProductPriceType } from "../../../../interfaces/interfaces";
import { ApiService } from "../../../../services/api.service";
import { combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-globizfeedimportmodule',
    templateUrl: './globizfeedimportmodule.component.html',
    styleUrls: ['./globizfeedimportmodule.component.scss']
})
export class GlobizFeedImportModuleComponent extends UnsubscribeComponent implements OnInit {
    @Input() module: AdminModuleDetail<ModuleGlobizFeedImportConfig> = null;

    whiteList: string = '';
    blackList: string = '';
    priceId: number = null;
    apiKey: string = '';
    categories: Category[] = [];
    leafCategories: Category[] = [];
    leafCategoriesLabelValue: LabelValueNumber[] = [
        { label: 'Nincs Kiválasztva', value: null }
    ];
    priceTypes: LabelValueNumber[] = [
        { label: 'Nincs kiválasztva', value: null }
    ];
    globizCategories: ModuleGlobizFeedImportCategory[] = [];
    categoryMatchers: ModuleGlobizFeedImportCategoryMatcher[] = [];

    @Output() inited: EventEmitter<boolean> = new EventEmitter();
    @Output() configChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private apiService: ApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.inited.emit(true);
        this.init();
    }

    init(): void {
        this.loadData();
    }

    loadData(): void {
        combineLatest([
            this.apiService.moduleFunctionGet<ModuleGlobizFeedImportCategory[]>(this.module.id, 'categories'),
            this.apiService.getCategories(),
            this.apiService.getSimpleTable('productpricetypes')
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(([globizCategoriesResponse, categoriesResponse, productPriceTypesResponse]) => {
            this.globizCategories = globizCategoriesResponse.data;
            this.categories = categoriesResponse.categories;
            this.recursiveNameCategories(this.categories, null);
            this.leafCategoriesLabelValue.push(...this.leafCategories.map((leafCategory: Category) => ({
                label: leafCategory.name,
                value: leafCategory.id
            })));
            this.convertToCategoryMatchers(this.globizCategories, this.categories, this.module.config.categories || []);
            this.priceTypes.push(...productPriceTypesResponse.data.map((priceType: ProductPriceType) => ({
                label: priceType.name,
                value: priceType.id
            })));
            this.whiteList = (this.module.config.whiteList || []).join('\r\n');
            this.blackList = (this.module.config.blackList || []).join('\r\n');
            this.priceId = this.module.config.priceId || null;
            this.apiKey = this.module.config.apiKey || '';
        });
    }

    recursiveNameCategories(categories: Category[], parent: Category = null): void {
        categories.forEach((category: Category) => {
            if (parent !== null) {
                category.name = parent.name + ' -> ' + category.name;
            }
            if (category.children.length > 0) {
                this.recursiveNameCategories(category.children, category);
            } else {
                this.leafCategories.push(category);
            }
        });
    }

    convertToCategoryMatchers(globizCategories: ModuleGlobizFeedImportCategory[], categories: Category[], pairs: ModuleGlobizFeedImportConfigCategories[]): void {
        const categoryMacthers: ModuleGlobizFeedImportCategoryMatcher[] = [];
        globizCategories.forEach((level1) => {
            level1.children.forEach((level2) => {
                level2.children.forEach((level3) => {
                    const categoryId: number = pairs.find((p: ModuleGlobizFeedImportConfigCategories) => {
                        return p.globizCategoryPath[0] === level1.id && p.globizCategoryPath[1] === level2.id && p.globizCategoryPath[2] === level3.id;
                    })?.webshopCategoryId || null;
                    categoryMacthers.push({
                        globizCategoryName: level1.name + ' &#187; ' + level2.name + ' &#187; ' + level3.name,
                        globizCategoryPath: [level1.id, level2.id, level3.id],
                        globizCategory: level3,
                        underEditing: false,
                        categoryId,
                        categoryName: this.leafCategories.find((c) => c.id === categoryId)?.name || null
                    });
                });
            });
        });
        this.categoryMatchers = categoryMacthers;
    }

    saveConfig(): void {
        const whiteList: string[] = this.whiteList.trim().length === 0 ? [] : this.whiteList.split(/\r?\n/);
        const blackList: string[] = this.blackList.trim().length === 0 ? [] : this.blackList.split(/\r?\n/);
        const config: ModuleGlobizFeedImportConfig = {
            apiKey: this.apiKey,
            whiteList,
            blackList,
            priceId: this.priceId,
            categories: this.categoryMatchers.map((categoryMatcher: ModuleGlobizFeedImportCategoryMatcher) => ({
                globizCategoryId: categoryMatcher.globizCategory.id,
                webshopCategoryId: categoryMatcher.categoryId,
                globizCategoryPath: categoryMatcher.globizCategoryPath
            }))
        };
        this.apiService.saveModuleConfig(this.module.id, config).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.configChanged.emit(false);
        });
    }

    changeCategory(matcher: ModuleGlobizFeedImportCategoryMatcher, id: number): void {
        matcher.categoryId = id;
        matcher.categoryName = this.leafCategories.find((c) => c.id === id)?.name || null;
        this.configChanged.emit(true);
    }

    apiKeyChanged(): void {
        this.configChanged.emit(true);
    }

    priceIdChanged(): void {
        this.configChanged.emit(true);
    }

    whiteListChanged(): void {
        this.configChanged.emit(true);
    }

    blackListChanged(): void {
        this.configChanged.emit(true);
    }
}